/**
 * @generated SignedSource<<48be64132a735bd84ba3fe991d523d65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespMainContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuDrawer_viewer" | "SbRespRefineMenuSelector_viewer" | "SbRespSearchResultContainer_viewer" | "SbSharedRecentlySoldItems_viewer" | "SbSharedRelatedItems_viewer">;
  readonly " $fragmentType": "SbRespMainContent_viewer";
};
export type SbRespMainContent_viewer$key = {
  readonly " $data"?: SbRespMainContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespMainContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespMainContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRecentlySoldItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ed1df5335cd9762878a84379ef3360ac";

export default node;
